import * as React from 'react';
import { keys } from '../../data/i18n';

export type Lang = 'en-us' | 'zh-sg';

const LocalizeContext = React.createContext<Lang>('en-us');

export const LocalizeProvider = LocalizeContext.Provider;

type ValueOf<T> = T[keyof T];

export const useLocalize = () => {
  const lang = React.useContext(LocalizeContext);

  return React.useCallback(
    function localize(text: keyof ValueOf<typeof keys>) {
      const translatedText = keys[lang] && keys[lang][text];
      if (typeof translatedText === 'undefined') {
        console.error(`Missing translation for ${text}.`);
      }
      return typeof translatedText === 'undefined' ? text : translatedText;
    },
    [lang]
  );
};

export const useLang = () => React.useContext(LocalizeContext);
